const LinkLine = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="3" height="164.049" viewBox="0 0 3 164.049">
            <g id="Group_14" data-name="Group 14" transform="translate(1.5 1.5)">
                <path id="Path_20" data-name="Path 20" d="M0,161.049V0" fill="none" stroke="#e2e2e2" stroke-linecap="round" stroke-width="3"/>
            </g>
        </svg>
    )
  }
  
export default LinkLine  